class Back {
	constructor($templateCache) {
		this.scope = {
			styles: '=?',
			mode: '=?'
		};

		this.restrict = 'E';
		this.link = this.BackLink;
	}

	BackLink(scope, element, attrs) {}
}

export default /* @ngInject */ ($templateCache) => new Back($templateCache);
